import {
  Dialog,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorSuccessDialogContent } from "../../modules/projects/components/ErrorSuccessDialogContent";

interface ErrorDialogProps {
  title: string;
  message: string;
  onClickClose: VoidFunction;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  title,
  message,
  onClickClose,
}) => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const tokens = useFoundationColorTokens();
  const typography = useTypography();

  return (
    <Dialog
      open
      title={title}
      secondaryButtonText={t("common.close")}
      onSecondaryButtonClick={onClickClose}
    >
      <ErrorSuccessDialogContent
        spacing={spacing}
        tokens={tokens}
        typography={typography}
        isError={true}
        errorSuccessText={message}
      />
    </Dialog>
  );
};
